import { Component, OnInit } from "@angular/core";
import { Location } from "@angular/common"; // Import the Location class from the '@angular/common' package
import {
  SignInInputModel,
  SignInOutputModel,
} from "src/app/admin/models/account-model";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { AuthService } from "src/app/shared/providers/auth/auth-service.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject } from "rxjs";
@Component({
  selector: "app-two-factor-auth",
  templateUrl: "./two-factor-auth.component.html",
  styleUrls: ["./two-factor-auth.component.scss"],
})
export class TwoFactorAuthComponent implements OnInit {
  userData: SignInInputModel;
  form: FormGroup;
  errorMessage: string;
  private _error = new Subject<string>();
  constructor(
    private location: Location,
    private authService: AuthService,
    private translate: TranslateService,
    private fb: FormBuilder
  ) {
    this.userData = this.location.getState() as SignInInputModel; // Use the 'getState' method on the 'location' object
  }
  ngOnInit(): void {
    this._error.subscribe((message) => (this.errorMessage = message));
    this.initForm();
    // console.log("userData", this.userData);
  }
  checklogin() {
    if (this.form.valid) {
      const code =
        this.form.controls["code1"].value +
        this.form.controls["code2"].value +
        this.form.controls["code3"].value +
        this.form.controls["code4"].value +
        this.form.controls["code5"].value +
        this.form.controls["code6"].value;

      // console.log("code", code);
      this.userData.code = code;
      this.authService.checkadminLogin(this.userData).subscribe(
        (result: SignInOutputModel) => {
          this.authService.handleAdminLogin(
            result,
            "/admin/InternalFranchises"
          );
        },
        (error) => {
          if (error.status == "403")
            //  this._error.next(error.error.error.message);
            this.translate
              .get(`AdminLogin.${error.error.error.message}`)
              .subscribe((msg) => this._error.next(msg));
          setTimeout(() => {
            this.errorMessage = "";
          }, 5000);
        }
      );
    } else {
      this.translate
        .get("AdminLogin.EmptyCode")
        .subscribe((msg) => this._error.next(msg));
      setTimeout(() => {
        this.errorMessage = "";
      }, 5000);
    }
    // console.log("form value", this.loginForm.value);
    // this.router.navigate(['admin/internalRestrictions']);
  }
  initForm() {
    this.form = this.fb.group({
      code1: this.fb.control(null, Validators.required),
      code2: this.fb.control(null, Validators.required),
      code3: this.fb.control(null, Validators.required),
      code4: this.fb.control(null, Validators.required),
      code5: this.fb.control(null, Validators.required),
      code6: this.fb.control(null, Validators.required),
    });
  }
}
